export const FilterAction = {
    GET_COMPANY: "get_company",
    GET_CROP_CATEGORY: "get_crop_category",
    GET_SHOP_COMPANY: "get_shop_company",
    SET_SELECTED_COMPANIES: "set_selected_companies",
    
    GET_LIST: "get_list",
    UPDATE_SEARCH_TEXT: "update_search_text",
    INIT_SEARCH_DTO_AND_SHOP_COMPANY_LIST: "init_search_dto_and_shop_company_list"
}